import { Form, Input } from 'antd'
import React from 'react'

import { EntryComponentsWrapper } from 'packages/theme'

import { CommonBasicInfo } from '@/components/CommonBasicInfo'

import { BasicInfoProps } from '../types'

/**
 * 问卷 - 基本信息
 *
 * @param param0 - 参数
 * @param param0.form - 表单实例
 * @param param0.basicInfoRef - 基本信息 ref
 * @param param0.commonBasicInfo - 基本信息
 * @param param0.setTitle - 设置标题
 * @param param0.activityTaskOptions - 任务选项
 * @param param0.isSubmit - 是否提交
 * @param param0.setDescription - 设置简介
 * @returns  component
 */
export const BasicInfo: React.FC<
  BasicInfoProps & { setDescription: (v: string) => void; isSubmit?: boolean }
> = ({
  form,
  basicInfoRef,
  commonBasicInfo,
  setTitle,
  setDescription,
  activityTaskOptions,
  isSubmit,
}) => {
  return (
    <EntryComponentsWrapper>
      <Form
        colon={false}
        form={form}
        wrapperCol={{ span: 22 }}
        labelCol={{ span: 2 }}
        initialValues={{
          isShow: true,
        }}
      >
        <Form.Item
          label="问卷标题"
          name="name"
          rules={[{ required: true, message: '请输入问卷标题' }]}
        >
          <Input
            placeholder="请输入课程标题"
            onChange={(e) => {
              setTitle && setTitle(e.target.value)
            }}
            maxLength={200}
          />
        </Form.Item>
        <Form.Item
          label="问卷简介"
          name="description"
        >
          <Input.TextArea
            placeholder="输入文本"
            style={{ minHeight: 82 }}
            onChange={(e) => {
              setDescription && setDescription(e.target.value)
            }}
            maxLength={500}
            autoSize
          />
        </Form.Item>
        <CommonBasicInfo
          form={form}
          ref={basicInfoRef}
          value={commonBasicInfo}
          activityTaskOptions={activityTaskOptions || []}
          openTypeDisabled={!!isSubmit}
        />
      </Form>
    </EntryComponentsWrapper>
  )
}
